<template>
  <v-card>
    <v-card-text>
      <v-form @submit.prevent="handleSubmit">
        <form-group
          name="name"
          attribute="fields.name"
          :validator="$v.label.name"
        >
          <template slot-scope="{ attrs }">
            <v-text-field
              v-bind="attrs"
              :loading="fetchLoading"
              v-model="label.name"
              @blur="$v.label.name.$touch()"
            ></v-text-field>
          </template>
        </form-group>

        <v-color-picker
          :show-swatches="true"
          :hide-inputs="true"
          style="alig"
          v-model="label.color"
          class="mt-2"
        ></v-color-picker>

        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            :loading="submitLoading"
            :disabled="submitLoading || fetchLoading"
            color="primary"
            type="submit"
          >
            {{ $t("button.save") }}
            <v-icon right dark>mdi-content-save-move-outline</v-icon>
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { updateLabel, fetchLabel, createLabel } from "@/api/labels";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "LabelForm",
  watch: {
    locale() {
      this.fetchLabel();
    }
  },
  props: {
    locale: {
      type: String,
      default: "en"
    },
    // we supply this prop from edit page to tell our form that we are going to edit label data so call fetchLabel request
    isUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // main Entitie
      label: {
        name: "",
        color: "#941694"
      },
      // Loading State
      submitLoading: false,
      fetchLoading: false
    };
  },
  created() {
    // isUpdate means we currently Editing an item
    // isUpdate State fetch current label based on route id
    if (this.isUpdate && this.$route.params.id) {
      this.fetchLabel();
    }
  },
  methods: {
    fetchLabel() {
      this.fetchLoading = true;
      const id = this.$route.params.id;
      fetchLabel(id, this.locale)
        .then(res => {
          this.fetchLoading = false;
          this.label = res.data.label;
        })
        .catch(() => {
          this.fetchLoading = false;
        });
    },
    handleSubmit() {
      this.$v.$touch();
      // if Current Validation is invalid return. (dont make request)
      if (this.$v.$invalid) {
        return;
      }
      // Else setLoading state to true then do api request
      this.submitLoading = true;
      this.isUpdate ? this.updateLabel() : this.createLabel();
    },
    createLabel() {
      const reqData = this.initReqData();
      createLabel(reqData)
        .then(() => {
          this.afterSuccess();
        })
        .catch(() => {
          this.afterError();
        });
    },
    updateLabel() {
      const id = this.$route.params.id;
      const reqData = this.initReqData();
      updateLabel(id, reqData)
        .then(() => {
          this.afterSuccess();
        })
        .catch(() => {
          this.afterError();
        });
    },
    // helper function to init our request data object
    initReqData() {
      return { ...this.label, locale: this.locale };
    },
    afterSuccess() {
      this.submitLoading = false;
      this.$router.push({ name: "labelsList" });
    },
    afterError() {
      this.submitLoading = false;
    }
  },
  validations: {
    label: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(30)
      },
      color: {
        required
      }
    }
  }
};
</script>
